
import {
    DetailsListLayoutMode, IColumn, IContextualMenuItem, Label, Panel, PanelType, Selection, SelectionMode
} from '@fluentui/react';
import { RootState } from 'app/store';
import CollapsiblePanel from "components/controls/CustomPanel";
import { addUpdateNonStandards, addUpdateNonStandardTemplates } from 'global/Reducer/dataSlice';
import { copyPropertiesOnly } from 'global/Utility/TSFunctions';
import * as IXrmTypes from 'model/CRM';
import * as FAM from 'model/FlexibleAttributeModel';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { createNonStandard, createNonStandardColumns, createNonStandardTemplateColumns, EViewType } from "../../global/Application";
import { RouterParams } from 'App';
import CustomDetailList from 'components/controls/CustomDetailList';
import { DefaultGridConfig } from 'components/controls/CustomDetailList/CustomDetailList';
import { ICustomDetailListConfiguration } from 'components/controls/CustomDetailList/ICustomDetailListConfiguration';
import { IGridItem } from 'components/controls/CustomDetailList/IGridItem';
import { useApplication } from 'global/Application/Context';
import { updateCustomDetailListConfiguration } from 'global/Reducer/statusSlice';

import { useHistory, useParams } from 'react-router-dom';
import NonStandardTemplateEditor from './NonStandardTemplateEditor';
import NonStandardTemplateCategoryLookup from './NonStandardTemplateCategoryLookup';
import NonStandardTemplateView from './NonStandardTemplateView';

interface IProps extends TComponentConnectedProps {
    groupConfiguration?: FAM.IGroupConfigurationData;
    benefit?: FAM.IBenefit;
    section?: IXrmTypes.bcbs_config_section;
    disabled?: boolean;
    nonStandardTemplates?: FAM.INonStandardTemplate[];
    variant?: 'importer' | 'default';
    tierNames?: Record<string, FAM.ITierLevel>
}


const gridStyles = {
    root: {
        marginBottom: '1.45em',
        marginTop: '6px',
    },
    headerWrapper: {
        selectors: {
            '.ms-DetailsHeader': {
                paddingTop: '0px',
            },
        }
    }
};

type TNonstandardTemplateGridItem = IGridItem<FAM.INonStandardTemplate>;

const NonStandardTemplateGridView = (props: IProps) => {
    const readOnly = props.state.status.viewType !== EViewType.Modify;
    const dispatch = useDispatch();
    const application = useApplication();
    const history = useHistory();
    const [nonStandardTemplate, setNonStandardTemplate] = useState<FAM.INonStandardTemplate | null>(null);
    const [nonStandardTemplateEditorIsMounted, setNonStandardTemplateEditorIsMounted] = useState(false);
    const [nonStandardTemplateEditorIsOpen, _setNonStandardTemplateEditorIsOpen] = useState(false);

    const [nonStandardTemplateViewerIsMounted, setNonStandardTemplateViewerIsMounted] = useState(false);
    const [nonStandardTemplateViewerIsOpen, _setNonStandardTemplateViewerIsOpen] = useState(false);
    //const setNonStandardTemplateViewerIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
    //    if (!nonStandardTemplateViewerIsMounted)
    //        setNonStandardTemplateViewerIsMounted(true);
    //    _setNonStandardTemplateViewerIsOpen(value);
    //}


    const [nonStandardTemplateApplyIsMounted, setNonStandardTemplateApplyIsMounted] = useState(false);
    const [nonStandardTemplateApplyIsOpen, _setNonStandardTemplateApplyIsOpen] = useState(false);
   
    const [selectionCount, setSelectionCount] = useState(0);
    const [selectedItems, setSelectedItems] = useState<FAM.INonStandardTemplate[] | null>(null);

    const params = useParams<RouterParams>()

    const categoryGroupConfiguration = props.state.data.config.cache.map_bcbs_config_category_named['Group Configuration'];
    const categoryNonStandardTemplate = props.state.data.config.cache.map_bcbs_config_category_named['Non-Standard Template'];

    let disabled = props.disabled;

    const disableAddingNonstandardByChangeType =
        (props.benefit && !application.ChangeTypePermissions.canAddBenefitNonstandard) ||
        (props.groupConfiguration && !application.ChangeTypePermissions.canAddGroupConfigurationNonstandard);

    // if not disabled and for benefit but can not add nonstandard to benefit
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    // if not disabled and for group configuration but can not add nonstandard to group configuration
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    //const storageId = `nonstandard.grid(${props.section!.bcbs_config_sectionid})`;
    const storageId = `randomStorageID`

    const scopeGridConfig = () => {
        const u = props.state.status.gridConfigs[storageId];
        if (u)
            return u;

        const t = DefaultGridConfig();
        t.sort = [{ column: { key: 'nonStandardName' }, isSortedDescending: false }];

        return t;
    }

    const [gridConfig, setGridConfig] = useState<ICustomDetailListConfiguration>(scopeGridConfig());
    const gridConfigRef = useRef(gridConfig);

    // check if it has changed since mounting
    if (gridConfig !== gridConfigRef.current) {

        gridConfigRef.current = gridConfig;

        // snapshot for bind back
        dispatch(updateCustomDetailListConfiguration({ id: storageId, gridConfig: structuredClone(gridConfig) }));
    }

    const onColumnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
        setGridConfig(t => {

            const gridConfig: ICustomDetailListConfiguration = { ...t };

            gridConfig.sort = [{
                column: { key: column.key },
                isSortedDescending: !t?.sort?.[0]?.isSortedDescending ?? false,
            }];


            return gridConfig;
        });
    };


    //get the non standards for whatever we are getting
    let scopeNonStandards: FAM.INonStandardTemplate[] = [];

    if (props.groupConfiguration)
        scopeNonStandards = props.groupConfiguration.nonStandardTemplates;

    // externally supplied non standards?
    if (props.nonStandardTemplates)
        scopeNonStandards = props.nonStandardTemplates;


    //useEffect(() => {
    //    if (history.location.search === '?navigation=pending')
    //        if (params.nonStandardId)
    //            setTimeout(() => {
    //                const nonstandard = scopeNonStandards.find(t => t.id === params.nonStandardId);
    //                if (nonstandard) {
    //                    const section = props.state.data.config.cache.map_bcbs_config_section[nonstandard?.sectionRef?.id!];
    //                    const tab = props.state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];
    //                    if (section.bcbs_config_sectionid === props.section.bcbs_config_sectionid) {
    //                        onSelect([nonstandard]);

    //                        if (!params.field2ndId && !params.tab2ndId && !params.section2ndId)
    //                            history.push({ pathname: history.location.pathname, search: '?navigation=complete' });
    //                    }
    //                }
    //            }, 200);
    //}, []);

    useEffect(() => {
        console.log("nonStandardTemplate state updated:", nonStandardTemplate);
    }, [nonStandardTemplate]);


    const menu: IContextualMenuItem[] = [];

    if (selectionCount > 0) {
        if (!readOnly) {
            menu.push({
                key: `nonStandardTemplate.Edit`,
                name: 'Edit',
                icon: 'PageEdit',
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    let selectedItems = selection.current.getSelection() as TNonstandardTemplateGridItem[];

                    if (selection.current.isAllSelected())
                        selectedItems = items;

                    onSelect(selectedItems.map(q => q.data!));
                    setNonStandardTemplateEditorIsMounted(true);
                    _setNonStandardTemplateEditorIsOpen(true);
                }
            });
        }

        menu.push({
            key: `nonStandardTemplate.View`,
            name: 'View',
            icon: 'PageEdit',
            onClick: (event, item) => {
                if (event?.stopPropagation)
                    event.stopPropagation();

                let selectedItems = selection.current.getSelection() as TNonstandardTemplateGridItem[];

                //if (selection.current.isAllSelected())
                //    selectedItems = items;
                
                onSelect(selectedItems.map(q => q.data!));
                
                if (nonStandardTemplate) {
                    setNonStandardTemplateViewerIsMounted(true);
                    _setNonStandardTemplateViewerIsOpen(true);
                }
            }
        });
    }

    const onSelect = (selectedItems: FAM.INonStandardTemplate[]) => {
        //if (!props.section)
        //    throw new Error('section has not been identified.');

        if (selectedItems && selectedItems.length === 1) {
            const _t = selectedItems[0];

            setNonStandardTemplate(structuredClone(_t));
        } 
    }


    const columns = useMemo(() => {

        // nonstandard must be defined for a section
        //if (!props.section)
        //    return [];

        // generating a temporary non-standard to match the schema
        const columns = createNonStandardTemplateColumns(
            props.state.data.config,
            {
                category: categoryNonStandardTemplate,
                config: props.state.data.config,
                linkedCategory: null,
            },
            gridConfig,
            onColumnClick
        );
        return columns;

    }, [gridConfig.filter, gridConfig.sort]);

    const [items, itemsPaged] = useMemo(() => {
        
        const items: TNonstandardTemplateGridItem[] = [];


        const gridConfigMappedColumns = {
            filterColumns: gridConfig.filter.map(q => columns?.find(w => w.key === q.column.key)),
            sortColumns: gridConfig.sort.map(q => columns?.find(w => w.key === q.column.key)),
        }
        scopeNonStandards.forEach((eNonStandardTemplate, index) => {

            // skip deactivated records/only show deactivated records if permitted at group config properties level (xnor)
            if (eNonStandardTemplate.deactivated !== props.state.data.json.showInActives?.value)
                return;

            
            const item: TNonstandardTemplateGridItem = {
                key: eNonStandardTemplate.id,
                name: eNonStandardTemplate.name,
                linkedCategoryName: eNonStandardTemplate.linkedCategoryName,
                _index: index,
                data: eNonStandardTemplate
            };

            eNonStandardTemplate.fields.forEach(eaField => {
                const configAttributeId = eaField.configRef.id;
                // lets always get the first one
                // verified with William there will never be a Tier/PCP/Specialist mode for these.

                eaField.values.forEach(eachFieldValue => {

                    item[`${configAttributeId}-${eachFieldValue?.tierRef?.id ?? ''}`] = eachFieldValue.value;
                });
            });

            // Filtering :
            let include = true;
            if (gridConfig && gridConfig.filter && gridConfig.filter.length > 0) {
                gridConfig.filter.forEach((filter, ix) => {
                    const column = gridConfigMappedColumns.filterColumns[ix];
                    if (column) {
                        const predicate = column.filterPredicate;
                        if (predicate)
                            include = include && predicate(item, filter.value, column);
                    }
                });
            }

            if (include)
                items.push(item);

            
        });


        if (gridConfig && gridConfig.sort && gridConfig.sort.length > 0)
            items.sort((a, b) => {

                let ret = 0;

                gridConfig.sort?.forEach((sort, ix) => {
                    const column = gridConfigMappedColumns.sortColumns[ix];

                    // TODO why was this needed?
                    if (!column)
                        return;

                    const predicate = column.sortPredicate;
                    const isSortedDescending = sort.isSortedDescending ?? false;

                    if (predicate)
                        ret = ret || isSortedDescending
                            ? predicate(a, b, undefined, column) * -1
                            : predicate(a, b, undefined, column);
                });

                return ret;

            });


        const itemsPaged = items.slice((gridConfig.page - 1) * gridConfig.pageSize, gridConfig.page * gridConfig.pageSize);
        return [items, itemsPaged];
        // return items;
    },
        [
            props.groupConfiguration?.nonStandards,
            props.benefit?.nonStandards,
            props.nonStandardTemplates,
            props.state?.data?.json?.showInActives?.value,
            gridConfig.filter,
            gridConfig.sort,
            gridConfig.page,
        ]
    );

    const selection = useRef(new Selection({
        onSelectionChanged: () => {
            const selectionCount = selection.current.getSelectedCount();
            const selectedItems = selection.current.getSelection() as TNonstandardTemplateGridItem[];
            setSelectionCount(selectionCount);
            if (selectedItems && selectedItems.length === 1) {
                const _t = selectedItems[0].data ?? null;

                setNonStandardTemplate(_t);
            } 
        },
        selectionMode: SelectionMode.multiple,
    }))

    const onRenderEditor = () => {
        if (!nonStandardTemplateEditorIsMounted)
            return <></>;

        const costshareCategory = props.benefit ?? categoryGroupConfiguration;

        return <NonStandardTemplateEditor
            isOpen={nonStandardTemplateEditorIsOpen}
            onDismiss={() => { _setNonStandardTemplateEditorIsOpen(false); setNonStandardTemplateEditorIsMounted(false); }}
            defaultValue={nonStandardTemplate ?? null}
            benefit={props.benefit}
            onChange={(nonStandardTemplate, changeTracker) => {
                let dispatchNonStandardTemplates = [nonStandardTemplate];

                dispatch(
                    addUpdateNonStandardTemplates([
                        {
                            nonStandardTemplates: dispatchNonStandardTemplates,
                        }]
                    )
                );

                _setNonStandardTemplateEditorIsOpen(false);
                setSelectedItems(null);
            }}
            openViewer={() => {
                _setNonStandardTemplateEditorIsOpen(false);
                setNonStandardTemplateApplyIsMounted(true);
                _setNonStandardTemplateApplyIsOpen(true);
            }}
        />
    }

    const onRenderApplyToCategory = () => {
        if (!nonStandardTemplateApplyIsMounted)
            return <></>;

        return <NonStandardTemplateCategoryLookup
            isOpen={nonStandardTemplateApplyIsOpen}
            onDismiss={() => {
                _setNonStandardTemplateApplyIsOpen(false);
                setNonStandardTemplateApplyIsMounted(false);
            }}
            nonStandardTemplate={nonStandardTemplate!}
        />
    }

    const onRenderRelationView = (rel: FAM.ITemplateRelationship) => { 
        let categoryName = "";
        //check the gc or benefits for the relationship id
        if (props.state.data.json.id === rel.categoryID)
        {
            categoryName = props.state.data.json.name;
        }
        else{
            var benefit = props.state.data.json.benefits.find(ben => ben.id === rel.categoryID);
            if (benefit) categoryName = benefit.name;
        }

        return <div>
            <CollapsiblePanel
                title={categoryName + " - " + rel.categoryType}
                id={`nonStandardTemplateVeiw.${categoryName}`}
                canCollapse={true}
                mountWhenExpanded={true}
                storageId={`nonstandardtemplateview(${props.groupConfiguration?.id})`}
            >
            {rel?.sectionRefs?.map((section) => (
                onRenderSectionView(section)
            ))}
            </CollapsiblePanel>
            </div>
        


    }

    const onRenderSectionView = (section: FAM.ITemplateSectionRelationship) => {
        let sectionName = "";
        //check the gc or benefits for the relationship id
        let foundSection = props.state.data.config.sections.find(sec => sec.bcbs_config_sectionid === section.sectionId);

        if (foundSection)
        {
            sectionName = foundSection.bcbs_name ?? "Undefined Section"
        }

        return <div>
            <CollapsiblePanel
                title={sectionName}
                id={`nopnStandardTemplateVeiw.${sectionName}-${section.sectionId}`}
                canCollapse={true}
                mountWhenExpanded={true}
                storageId={`nonstandardtemplateview(${props.groupConfiguration?.id})`}
            >
                {section.nonstandards?.map((nonstandard) => (<Label>{nonstandard.name}</Label>))}
            </CollapsiblePanel>
        </div>



    }

    const onRenderView = () => {
        if (!nonStandardTemplateViewerIsMounted)
            return <></>;

        return <NonStandardTemplateView
            isOpen={nonStandardTemplateViewerIsOpen}
            onDismiss={() => { _setNonStandardTemplateViewerIsOpen(false); setNonStandardTemplateViewerIsMounted(false) }}
            nonStandardTemplate={nonStandardTemplate ?? null}
        />
        

    }

    const onRenderGrid = () => {
        return <CustomDetailList
            items={items}
            columns={columns}
            gridConfig={[gridConfig, setGridConfig]}
            quickSearchColumnKey={'nonStandardName'}
            selectionMode={SelectionMode.single}
            styles={gridStyles}
            layoutMode={DetailsListLayoutMode.fixedColumns}
            selection={selection.current}
            onShouldVirtualize={() => false}
            getKey={(item) => { return item.key }}
        />;
    }
    

    
    const onRender = () => {
        return <div>
            {onRenderApplyToCategory()}
            {onRenderEditor()}
            {onRenderView()}
            <CollapsiblePanel
                title='Non-Standard Templates'
                id={`nopnStandardTemplates.${props.groupConfiguration?.id}`}
                canCollapse={true}
                mountWhenExpanded={true}
                storageId={`nonstandardtemplates(${props.groupConfiguration?.id})`}
                items={menu}
            >
                {onRenderGrid()}
            </CollapsiblePanel>
        </div>
    }

    return onRender();
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(NonStandardTemplateGridView);
